import React from 'react';

export function Dashboard(props) {
    return (
        <div>
            <h4>Welcome to QualityWorx</h4>
            <p>Easily create and manage your Non-Conformance Reports (NCRs).</p>
        </div>
    );
}